import { t } from 'i18next';

export const displayDate = (date: string, fallback?: string): string => {
  return date ? new Date(date).toLocaleDateString() : fallback ?? t('common.na');
};

/**
 * This function handles pulling the time portion of a date out and formatting
 * it for the expected string in an HTML input element with the type set to
 * time.
 *
 * @param date Date to pull the time information from
 *
 * @return string formatted as `HH:MM:SS`
 *
 * @example
 *
 * // Example date where the time is set to 01:10:30
 * const exampleDate = new Date(null, null, null, 1, 10, 30);
 *
 * // exampleDateString is 01:10:30
 * const exampleDateString = formatHTMLInputTime(exampleDate);
 */
export const formatHTMLInputTime = (date: Date) => {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
};
